import React, { Component } from 'react';
import s from './DriverSettingsForm.css';
import { Field, reduxForm, getFormValues, change, formValueSelector } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
//Style
import cx from 'classnames';
import {
	Form,
	Col,
	Card,
	Row,
	FormGroup,
	FormControl,
	Container
} from 'react-bootstrap';

import ColorPickerModal from '../DeliveryModule/ColorPickerModal';
import Dropzone from './Dropzone.js';
import Loader from '../../Common/Loader/Loader';

import { openColorModal } from '../../../actions/siteadmin/modalActions';

import { api, homepageUploadDir } from '../../../config';
import messages from '../../../locale/messages';
import validate from './validate';

//image
import defaultIcon from '../../../../public/Icons/defaultIconAdmin.svg';
import colorPickerIcon from '../../../../public/Icons/colorPickerIcon.svg';

export class DriverSettingsForm extends Component {

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, disabled }) => {
		const { formatMessage } = this.props.intl
		return (
			<Form.Group className={cx(s.space5, 'positionRelative')}>
				<Form.Label className={'inputLabel'}>{label}</Form.Label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} disabled={disabled} />
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl
		return (
			<FormGroup className={cx(s.space5, 'positionRelative')}>
				<label className={'inputLabel'}>{label}</label>
				<FormControl
					{...input}
					className={className}
					placeholder={label}
					as="textarea"
					rows="4"
				>
					{children}
				</FormControl>
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</FormGroup>
		);
	}

	render() {
		const { handleSubmit, safetyGridImage4, safetyGridImage5, safetyGridImage6, loading, submitting, driverAppBgColor, openColorModal } = this.props;
		const { formatMessage } = this.props.intl;
		return (
			<div>
				<Container fluid>
					<ColorPickerModal formName={'DriverSettingsForm'} />
					<h1 className={cx(s.heading, 'textAlignRightRTL')}>{formatMessage(messages.signupSectionSettings)}</h1>
					<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
						<Row>
							<Col xl={12} lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
								<div className={s.blackCenterSection}>
									<Col lg={12} md={12} sm={12} xs={12}>
										<Row>
											<Col lg={6} md={6} sm={6} xs={12}>
												<Field name="safetyGridTitle2" type="text" component={this.renderField} label={formatMessage(messages.driverAppTitle)} />
												<Field name="safetyGridLink3" type="text" component={this.renderField} label={formatMessage(messages.playStoreLink)} />
												<Field name="safetyGridLink4" type="text" component={this.renderField} label={formatMessage(messages.appStoreLink)} />
												<div className={s.positionRelative}>
													<Field
														name="driverAppBgColor"
														type="text"
														placeholder={formatMessage(messages.bgColor)}
														component={this.renderField}
														label={formatMessage(messages.bgColor)}
														labelClass={s.labelText}
														fieldClass={s.formControlInput}
													/>
													<div className={cx(s.pickerIcon, 'pickerIconRTL')} onClick={(e) => openColorModal('driverAppBgColor', driverAppBgColor)} ><img src={colorPickerIcon} /></div>
												</div>
											</Col>
											<Col lg={6} md={6} sm={6} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<label>{formatMessage(messages.signupImage3)}</label><br />
														{
															safetyGridImage6 &&
															<div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir}${safetyGridImage6})` }} />
														}
														{
															!safetyGridImage6 &&
															<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
														}
														<div>
															<Dropzone
																className={cx(s.btnSecondary, s.profileNoPadding)}
																subTextClass={s.subText}
																fieldName={'safetyGridImage6'}
																subText={formatMessage(messages.maximumUploadSizeLabel)}
																defaultMessage={formatMessage(messages.chooseFile)}
																inputContainer={'.dzInputContainerSafetyImage3'}
																inputContainerClass={'dzInputContainerSafetyImage3'}
															/>
														</div>
													</div>
												</Form.Group>
											</Col>
										</Row>
										<Row>
											<Col lg={6} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<label>{formatMessage(messages.safetyImage1)}</label><br />
														{
															safetyGridImage4 &&
															<div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir}${safetyGridImage4})` }} />
														}
														{
															!safetyGridImage4 &&
															<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
														}

														<div>
															<Dropzone
																className={cx(s.btnSecondary, s.profileNoPadding)}
																subTextClass={s.subText}
																fieldName={'safetyGridImage4'}
																subText={formatMessage(messages.maximumUploadSizeLabel)}
																defaultMessage={formatMessage(messages.chooseFile)}
																inputContainer={'.dzInputContainerSafetyImage1'}
																inputContainerClass={'dzInputContainerSafetyImage1'}
															/>
														</div>
													</div>
												</Form.Group>
											</Col>
											<Col lg={6} md={12} sm={12} xs={12}>
												<Form.Group className={s.space3}>
													<div className={cx(s.profileImgSection, s.profileImgWidth)}>
														<label>{formatMessage(messages.safetyImage2)}</label><br />
														{
															safetyGridImage5 &&
															<div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir}${safetyGridImage5})` }} />
														}
														{
															!safetyGridImage5 &&
															<div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
														}
														<div>
															<Dropzone
																className={cx(s.btnSecondary, s.profileNoPadding)}
																subTextClass={s.subText}
																fieldName={'safetyGridImage5'}
																subText={formatMessage(messages.maximumUploadSizeLabel)}
																defaultMessage={formatMessage(messages.chooseFile)}
																inputContainer={'.dzInputContainerSafetyImage2'}
																inputContainerClass={'dzInputContainerSafetyImage2'}
															/>
														</div>
													</div>
												</Form.Group>
											</Col>
										</Row>
									</Col>
								</div>
							</Col>
							<Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, s.bottomPadding, 'bottomPaddingRTL', 'textAlignLeftRTL')}>
								<Form.Group className={s.noMargin}>
									<div className={s.displayInlineBlock}>
										<Loader
											type={"button"}
											label={formatMessage(messages.submitButton)}
											show={loading}
											buttonType={'submit'}
											className={cx(s.button, s.btnPrimary)}
											disabled={submitting || loading}
											isSuffix={true}
										/>
									</div>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Container>
			</div>
		)
	}
}

DriverSettingsForm = reduxForm({
	form: 'DriverSettingsForm',
	onSubmit: submit,
	validate
})(DriverSettingsForm);

const selector = formValueSelector('DriverSettingsForm')
const mapState = (state) => ({
	safetyGridImage4: selector(state, 'safetyGridImage4'),
	safetyGridImage5: selector(state, 'safetyGridImage5'),
	safetyGridImage6: selector(state, 'safetyGridImage6'),
	driverAppBgColor: selector(state, 'driverAppBgColor'),
	loading: state.loader.DriverSettingsForm,
})

const mapDispatch = {
	openColorModal
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DriverSettingsForm)));